import classNames from 'classnames'
import { ReactComponent as MinusIcon } from 'src/assets/svg/minus.svg'
import { ReactComponent as CheckIcon } from 'src/assets/svg/checkmark.svg'

interface OnboardingListItemProps {
  completed: boolean
  children: React.ReactNode
}

export function OnboardingListItem({
  completed,
  children
}: Readonly<OnboardingListItemProps>) {
  return (
    <li
      className={classNames(
        'favorite-chef-step__list-item',
        'onboarding-list-item',
        {
          'favorite-chef-step__list-item--completed': completed
        }
      )}>
      {completed ? <CheckIcon /> : <MinusIcon />}
      {children}
    </li>
  )
}
